import {
  Environment,
  handleFailedResponse,
} from '@agilelab/plugin-wb-platform-common';
import { DiscoveryApi, FetchApi } from '@mainstage/core-plugin-api';
import crossFetch from 'cross-fetch';

type Credentials = {
  token?: string;
};

export interface EnvironmentApi {
  getEnvironments(credentials: Credentials): Promise<Environment[]>;
  getAccessibleEnvironments(credentials: Credentials): Promise<Environment[]>;
}

export class DefaultEnvironmentApi implements EnvironmentApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;
  private readonly baseUrlPromise: Promise<string>;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi?: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.baseUrlPromise = this.discoveryApi.getBaseUrl('environment');
    this.fetchApi = options.fetchApi || { fetch: crossFetch };
  }

  async getEnvironments(credentials: Credentials): Promise<Environment[]> {
    const response = await this.fetchEnvironmentResponse(
      '/environments',
      credentials,
    );
    await handleFailedResponse(response);

    return response.json();
  }

  async getAccessibleEnvironments(
    credentials: Credentials,
  ): Promise<Environment[]> {
    const response = await this.fetchEnvironmentResponse(
      '/v1/environments/accessible',
      credentials,
    );
    try {
      await handleFailedResponse(response);
    } catch (error) {
      Object.assign(error, { status: response.status });
      throw error;
    }

    return response.json();
  }

  private async fetchEnvironmentResponse(
    path: string,
    credentials: Credentials,
  ): Promise<Response> {
    const baseUrl = await this.baseUrlPromise;

    return this.fetchApi.fetch(`${baseUrl}${path}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${credentials.token}`,
        'Content-Type': 'application/json',
      },
    });
  }
}
